let graphqlServerUrl              = "https://server.webpro.vladcesily.cz/graphql";
let serverUrl                     = "https://server.webpro.vladcesily.cz";

if (process && process.env && process.env.NODE_ENV === "development") {
    graphqlServerUrl              = "http://localhost:8908/graphql";
    serverUrl                     = "http://localhost:8908";
}

export const GRAPHQL_SERVER_URL              = graphqlServerUrl;
export const SERVER_URL                      = serverUrl;

export const WEB_URL                         = "https://webpro.vladcesily.cz";
export const TINYMCE_IMAGE_URL               = "Public/Images/TinyMCE";
export const TINYMCE_FILE_URL                = "Public/Files/TinyMCE";
export const MARKETING_IMAGE_URL             = "Public/Images/Marketing";
export const ARTICLE_IMAGE_URL               = "Public/Images/Article";
export const CONTENT_MANAGER_IMAGE_URL       = "Public/Images/ContentManager";
